import Form from '../Form';
import './style.scss';
const ContactArea = ({ className }) => {
  return (
    <div className={className}>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-5 col-12'>
            <div className='contactInfo'>
              <span>Get In Touch With Me</span>
              <br />
              <h2>Send Me An Email</h2>
              <h6>
                Call me at 1.604.927.2155 or send us a message using this form.
              </h6>
              <p>
                Give me a call or send a message to let me know how I can help.
              </p>
            </div>
          </div>
          <div className='col-12 col-lg-7'>
            <Form />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ContactArea;
